export default __webpack_public_path__ + "static/media/4_2_hl.99f6ab35.png";